import angular from 'angular';
import { BeaconFields } from './BeaconFields/BeaconFields';
import BeaconsService from './service';

const dspBeaconsDirective = (reactDirective, CreativeService) => {
  return reactDirective(
    BeaconFields,
    undefined,
    { restrict: 'E' },
    { CreativeService }
  );
};

dspBeaconsDirective.$inject = ['reactDirective', 'CreativeService'];

angular.module('generator.dsp.beacons', ['generator.creativePreview']);

angular
  .module('generator.dsp.beacons')
  .directive('dspBeacons', dspBeaconsDirective)
  .service('BeaconsService', BeaconsService);
